module.exports = __webpack_public_path__ + "img/enhanceable-logo.0d08e3db.png";